import { InjectionToken } from '@angular/core';
import { Environment } from '@environments/interface.environment';

export const CUSTOMERENVIRONMENT = new InjectionToken<Environment>('core-wp-customer-environment');
export const WINDOW = new InjectionToken('core-wp-window');
export const PORTAL_DATA = new InjectionToken('PORTAL_DATA');
